import {createFileRoute} from '@tanstack/react-router';

import {NewReimbursementPage} from '@/modules/reimbursements/pages/NewReimbursementPage';

export const Route = createFileRoute('/_authenticated/reimbursements/new')({
  component: NewReimbursementPage,
});
